import { lazy } from 'react';

import { staffCmsModalComponentByType } from '#/modules/staff/cms/modals/staffCmsModalComponentByType';
import { staffGradFairModalComponentByType } from '#/modules/staff/gradFairs/modals/staffGradFairModalComponentByType';

export const staffModalComponentByType = {
  DELETE_CONTENT: lazy(() =>
    import('./DeleteContent/StaffDeleteContentModalContainer').then(
      (module) => ({ default: module.StaffDeleteContentModalContainer }),
    ),
  ),
  STAFF_APPROVE_ITEM: lazy(() =>
    import('./ApproveItem/StaffApproveItemModal').then((module) => ({
      default: module.StaffApproveItemModal,
    })),
  ),
  STAFF_CHANGE_PASSWORD: lazy(() =>
    import('./StaffChangePassword/StaffChangePasswordModal').then((module) => ({
      default: module.StaffChangePasswordModal,
    })),
  ),
  CONFIRM_MERGE_ORG: lazy(() =>
    import('#/modules/staff/orgDashboard/modals/ConfirmMergeOrg/StaffOrgDashboardConfirmMergeOrgModal').then(
      (module) => ({ default: module.StaffOrgDashboardConfirmMergeOrgModal }),
    ),
  ),
  DELETE_CATEGORY: lazy(() =>
    import('./DeleteCategory/StaffDeleteCategoryModalContainer').then(
      (module) => ({ default: module.StaffDeleteCategoryModalContainer }),
    ),
  ),
  REFUND_PAYMENT_MODAL: lazy(() =>
    import('./RefundPayment/StaffRefundPaymentModal').then((module) => ({
      default: module.StaffRefundPaymentModal,
    })),
  ),
  VOID_LINE_ITEM: lazy(() =>
    import('./VoidLineItem/StaffVoidLineItemModalContainer').then((module) => ({
      default: module.StaffVoidLineItemModalContainer,
    })),
  ),
  CANCEL_CREDITS: lazy(() =>
    import('./CancelCredits/StaffCancelCreditsModal').then((module) => ({
      default: module.StaffCancelCreditsModal,
    })),
  ),
  STAFF_DELETE_EMAIL_PROMO: lazy(() =>
    import('./DeleteEmailPromo/StaffDeleteEmailPromoModal').then((module) => ({
      default: module.StaffDeleteEmailPromoModal,
    })),
  ),
  STAFF_DELETE_NOTIFICATION_CONFIGURATION: lazy(() =>
    import('./DeleteNotificationConfiguration/StaffDeleteNotificationConfigurationModal').then(
      (module) => ({
        default: module.StaffDeleteNotificationConfigurationModal,
      }),
    ),
  ),
  DELETE_JOB_FAMILY: lazy(() =>
    import('#/modules/staff/cms/compDb/modals/DeleteJobFamily/StaffDeleteJobFamilyModalContainer').then(
      (module) => ({ default: module.StaffDeleteJobFamilyModalContainer }),
    ),
  ),
  DELETE_JOB_TITLE: lazy(() =>
    import('./DeleteJobTitle/StaffDeleteJobTitleModal').then((module) => ({
      default: module.StaffDeleteJobTitleModal,
    })),
  ),
  STAFF_LOGIN_AS_USER: lazy(() =>
    import('./StaffLoginAs/StaffLoginAsModalContainer').then((module) => ({
      default: module.StaffLoginAsModalContainer,
    })),
  ),
  DELETE_LOCATION_GROUP: lazy(() =>
    import('./DeleteLocationGroup/StaffDeleteLocationGroupModalContainer').then(
      (module) => ({ default: module.StaffDeleteLocationGroupModalContainer }),
    ),
  ),
  DELETE_LOCATION: lazy(() =>
    import('./DeleteLandingPageLocation/StaffDeleteLandingPageLocationModalContainer').then(
      (module) => ({
        default: module.StaffDeleteLandingPageLocationModalContainer,
      }),
    ),
  ),
  ...staffCmsModalComponentByType,
  ...staffGradFairModalComponentByType,
} as const satisfies Record<string, unknown>;
